// import React, { useState } from "react";
// import ReactTooltip from 'react-tooltip';

function RoomReportTotalItem(props) {
    const { dayNames, days, getBackgroundColor,currentDate, handleMonthChange, type, room, handlePrev, handleNext  } = props;

    return (<div className="calendar-container">
          <header className="calendar-header">
            <button onClick={() => handlePrev(type)} style={{background:'aqua', fontSize:'2rem', width:'80px'}}>‹</button>
            <div className="calendar-title">
                <input
                  type="month"
                  onChange={e => handleMonthChange(e.target.value, type)}
                  value={currentDate === "" ? "" : `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`}
                  className="month-input"
                />
            </div>
    
            <button onClick={() =>handleNext(type)} style={{background:'aqua', fontSize:'2rem', width:'80px'}}>›</button> 
          </header>

          {
            <div className="calendar-grid" 
            // style={{display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '12px', fontSize: '1.2rem'}}
            >
                {Array.isArray(dayNames) && dayNames.map((name, index) => (
                    index < 7 && <div key={index} className="day-name" 
                                      style={{background: (name ==="Sun" || name === "Sat") ? '#ff0000e0' : "", padding: "4px", fontWeight:"500"}}
                                      >{name}</div>
                ))}

                {days.length > 0 &&  days.map((item, index) => (
                    item ? (
                        <div
                        key={index}
                        className={"day" + (index === props.active ? " active" : "")}
                    //  onClick={() => props.setActive(index)}
                        onMouseEnter={() => props.setActive(index)}
                    // data-tip={"React-tooltip"+type+"d"+index}
                        // data-tip
                        // data-for={"React-tooltip"+type+"d"+index}
                        style={{ backgroundColor: getBackgroundColor("guestNumber" in item ? Math.round((item.guestNumber / room)* 10000)/ 100 : item.percent,)}}
                        >
                        <div className="day-top">
                            <div className="day-number">{"data" in item ? item.data.slice(8,10) : item.date.slice(8,10)}</div>
                            {/* <div className="day-weekday">{item.weekday}</div> */}
                        </div>
                        <div className="day-percent">{"guestNumber" in item ? Math.round((item.guestNumber / room)* 10000)/ 100 : item.percent}%</div>

                        {/* <ReactTooltip place="top" type="dark" effect="float" id={"React-tooltip"+type+"d"+index}>
                            <div>MemberShip: {item.memberShip}</div>
                            <div>OTA: {item.OTA}</div>
                            <div>Late: {item.late}</div>
                            <div>Total Price: {item.totalPrice.toLocaleString()}$</div>

                        </ReactTooltip> */}


                        </div>
                    ) : (
                        <div key={index} className="day empty"></div>
                    )
                ))}
            </div>
          }
      </div>)
}

export default RoomReportTotalItem;
